import React, { Component } from 'react'
import { translate } from 'react-translate'
import Btn from '../../../../components/Buttons'
import { Col, Button, OverlayTrigger, Popover, Modal } from 'react-bootstrap'
import { ShareButtons, generateShareIcon } from 'react-share'
import FormContact from '../../../commons/ContactForm/ContactForm.container'
import { DIST_URL } from '../../../../constants/api'

@translate('Propiedad')
class Hotel extends Component {

  constructor (props) {
    super(props)

    this.state = {
      showModal: false
    }
    this.changeViewModal = this.changeViewModal.bind(this)
  }

  changeViewModal(e) {
    e.preventDefault()
    this.setState({showModal: !this.state.showModal })
  }

  toggle(e) {
    e.preventDefault()
  }

  render () {
    const { hotel, phone, t } = this.props
    let stars = (hotel.rating) ? parseInt(hotel.rating.replace(/\D/g, '')) : 0
    let arrayStars = []
    if (stars > 0){
      for (var i = 0; i < stars; i++){
        arrayStars.push('fa fa-star fa-lg')
      }
      if (arrayStars.length !== 5 ){
        for (var i = arrayStars.length; i < 5; i++){
          arrayStars.push('fa fa-star-o fa-lg')
        }
      }
    }

    let restStars = (hotel.rating) ? hotel.rating.id : ''
    let classes = (hotel.operation_type.name === 'Alquiler') ? 'propiedad-tipo' + ' ' + 'rent' : 'propiedad-tipo' + ' ' + 'sale'
    let province = hotel.neighborhood.province + ', ' + hotel.neighborhood.country
    let city = hotel.neighborhood.name + ', ' + hotel.neighborhood.province

    let operationName
				if (hotel.operation_type.name == 'Venta/Alquiler' ){
					operationName = `${t('Venta')} / ${t('Alquiler')}`
				}
				else{
					operationName = t(hotel.operation_type.name)
				}
    //share with social-networks

    let baseUrl = window.location.origin
    let shareUrl = baseUrl + '/' + hotel.uri
    const title = 'LJ Ramos'
    let description = hotel.observations

    const { FacebookShareButton, LinkedinShareButton, TwitterShareButton, WhatsappShareButton } = ShareButtons

    const FacebookIcon = generateShareIcon('facebook')
    const TwitterIcon = generateShareIcon('twitter')
    const LinkedinIcon = generateShareIcon('linkedin')
    const WhatsappIcon = generateShareIcon('whatsapp')

    const popoverShare = (
      <Popover id='popover-share'>
        <WhatsappShareButton
          url={shareUrl}
          title={title}>
          <WhatsappIcon
            size={20}
            round={false} />
        </WhatsappShareButton>
        <FacebookShareButton
          url={shareUrl}
          title={title}
          description={description}
          className=''>
          <FacebookIcon
            size={20}
            round={false} />
        </FacebookShareButton>
        <TwitterShareButton
          url={shareUrl}
          title={title}
          className=''>
          <TwitterIcon
            size={20} />
        </TwitterShareButton>
        <LinkedinShareButton
          url={shareUrl}
          title={title}
          className=''>
          <LinkedinIcon
            size={20} />
        </LinkedinShareButton>
      </Popover>
    )

    let telephone = 'tel:+5411' + phone.replace('-', '')
    let tel = phone.replace('-', '')

    let rooms = hotel.extra_attributes && hotel.extra_attributes.length
      ? hotel.extra_attributes.find(i => i.name.trim() === 'Cantidad de Habitaciones') : null
    rooms = rooms ? rooms.value : null
    rooms = !rooms && hotel.bedrooms  ? hotel.bedrooms : rooms

    return (
      <div>
        <div className='propiedad-container hidden-xs'>
          <Col md={6} sm={6}>
            <div className='propiedad-img'>
              <img src={hotel.image ? hotel.image : DIST_URL+'/assets/images/placeholder-hotels.png' } />
              <div className='wrapper'>
                <div className='wrapper-left'>
                  <div className={classes}>
                    {hotel.operation_type.name}
                  </div>
                </div>
                <div className='wrapper-right'>
                  <div className='propiedad-icons'>
                    <OverlayTrigger trigger='click' rootClose placement='top' overlay={popoverShare}>
                      <Button className='btn-icons' ref='target' onClick={(e) => this.toggle(e)}>
                        <i className='fa fa-share-alt fa-lg'></i>
                      </Button>
                    </OverlayTrigger>
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col md={6} sm={6}>
            <div className='propiedad-info'>
              <div className='container-fluid'>
                <div className='hot-title'>{province}</div>
                <div className='row'>
                  <div className='info info-location'>
                    <i className='fa fa-map-marker'></i>
                    <h3>{city}</h3>
                  </div>
                </div>
                <div className='info info-stars'>
                  <div className='row'>
                    { arrayStars.map((item, index) =>
                      <i className={item} key={index}></i>
                    )}
                  </div>
                </div>
                <div className='info info-description'>
                  <p className='description'>{hotel.observations}</p>
                </div>
                <div className='info bottom-info'>
                  <div className='item-left'>
                    <h3 className='cant-rooms'>{rooms || '-'}</h3>
                    <h3 className='rooms'> Habitaciones </h3>
                  </div>
                  <div className='item-right'>
                    <a
                      onClick={(e) => e.stopPropagation()}
                      target='_blank' href={`https://api.whatsapp.com/send?phone=54911${tel || '41141000'}&text=${t('Consulta_WhatsApp_Interesado')}: Hotel ${t('Consulta_WhatsApp_En')} ${operationName}%0A${t('Consulta_WhatsApp_Ubicado')} ${city}%0A${t('Consulta_WhatsApp_Codigo')}: ${hotel.property_code}`} rel='noreferrer'>
                      <div className='box-whatsapp'>
                        <i className='fa fa-whatsapp fa-lg'></i>
                        <p>Whatsapp</p>
                      </div>
                    </a>
                    <Btn type='submit' text='Contactar' clickButton={(e) => this.changeViewModal(e)} classes='btn-primary btn-propiedad' />
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </div>
        <div className='propiedad-container visible-xs'>
          <div className='col-xs-12'>
            <div className='propiedad-img'>
              <img src={hotel.image ? hotel.image : DIST_URL+'/assets/images/placeholder-hotels.png'} />
              <div className='wrapper'>
                <div className='wrapper-left'>
                  <div className={classes}>
                    {hotel.operation_type.name}
                  </div>
                </div>
              </div>
            </div>
            <div className='propiedad-info'>
              <div className='container-fluid'>
                <div className='hot-title'>{province}</div>
                <div className=''>
                  <div className='info'>
                    <i className='fa fa-map-marker'></i>
                    <h3>{city}</h3>
                  </div>
                </div>
                <div className='info'>
                  <div className=''>
                    { arrayStars.map((item, index) =>
                      <i className={item} key={index}></i>
                    )}
                  </div>
                </div>
                <div className='info'>
                  <div className='item-left'>
                    <h3 className='cant-rooms'>{rooms || '-'}</h3>
                    <h3 className='rooms'> Habitaciones </h3>
                  </div>
                  <div className='item-right'>
                    <Button className='btn-icon'>
                      <a onClick={(e) => e.stopPropagation()} target='_blank' href={`https://api.whatsapp.com/send?phone=54911${tel || '41141000'}&text=${t('Consulta_WhatsApp_Interesado')}: Hotel ${t('Consulta_WhatsApp_En')} ${operationName}%0A${t('Consulta_WhatsApp_Ubicado')} ${city}%0A${t('Consulta_WhatsApp_Codigo')}: ${hotel.property_code}`} rel='noreferrer'><i className='fa fa-whatsapp fa-2x'></i></a>
                    </Button>
                    <Button className='btn-icon'>
                      <a href={telephone}><i className='fa fa-phone fa-2x'></i></a>
                    </Button>
                    <Button className='btn-icon'>
                      <i className='fa fa-envelope fa-2x'></i>
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
            className='modal-contact-form'
            show={this.state.showModal}
            onHide={(e) => this.changeViewModal(e)}
            aria-labelledby='contained-modal-title'
            bsSize='large'
            >
            <Modal.Body>
              <div className='form-box'>
                <div className='form-content form-slider'>
                  <Col md={12} sm={12} className='inputs-form form-modal hidden-xs'>
                    <FormContact textareaDefault={false} property={hotel} />
                  </Col>
                  <div className='col-md-12 inputs-form visible-xs'>
                    <FormContact textareaDefault={false} property={hotel} />
                  </div>
                </div>
                <div className='box-close'>
                  <Button type='submit' onClick={(e) => this.changeViewModal(e)} className='btn-close'>
                    <i className='fa fa-times fa-lg'></i>
                  </Button>
                </div>
              </div>
            </Modal.Body>
          </Modal>
      </div>
    )
  }
}

export default Hotel



// WEBPACK FOOTER //
// ./src/features/PageHotels/components/HotelView/HotelView.component.js